/* @flow */

export const INITIAL_DATA_LOAD: string = 'calendar:INITIAL_DATA_LOAD';
export const INITIAL_DATA_LOAD_SUCCESS: string =
  'calendar:INITIAL_DATA_LOAD_SUCCESS';

export const loadInitialDatas = () => ({
  type: INITIAL_DATA_LOAD,
});



// WEBPACK FOOTER //
// ./src/modules/calendar/actions/index.js